import TabFinance from '@/components/comptable/dashboard/tab-finance'
import store_config from "@/store/mods/parametres/config"

export default {
    name: 'dashboard',
    components: {
        TabFinance
    },
    props: [],
    data () {
        return {
            liste_personnel_roles: []
        }
    },

    mounted () {
        this.fetchListeCaissieres()
    },

    methods: {
        fetchListeCaissieres() {
            store_config.selectListeCaissieres().then((response) => {
                this.liste_personnel_roles = response
                const all_user = {
                    id: "",
                    nom: 'Tous(tes) les caissiers(es)',
                    titre: "",
                }
                this.liste_personnel_roles.unshift(all_user)
            })
        },
    }
}
